import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IRegistrationSelectedSectionsModel } from '../models/registration_selected_sections_model';
import { RegisterSectionsQuery } from '../../course_scheduler/queries/register_sections_query';
import { RegistrationSelectedSectionsQuery } from '../queries/registration_selected_sections_query';

export type updateRegistrationFlagCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'updateRegistrationFlagCommand',
    (
      defineCommandORM: IDefineCommand,
      ngRegistrationSelectedSectionsModel: IRegistrationSelectedSectionsModel,
      ngRegisterSectionsQuery: RegisterSectionsQuery,
      ngRegistrationSelectedSectionsQuery: RegistrationSelectedSectionsQuery
    ) =>
      defineCommandORM('updateRegistrationFlagCommand', (deferred) => {
        ngRegistrationSelectedSectionsModel.write({
          disableRegistration:
            ngRegistrationSelectedSectionsQuery.result.isRegistrationPending ||
            _4.isEmpty(ngRegisterSectionsQuery.result.selectedSections)
        });

        return deferred.resolve();
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/commands/update_registration_flag_command.ts